const css = `.event-tooltip .event-details .event-professional-avatar, .calendar-event-container .event-professional-avatar {
  width: 24px;
  height: 24px;
}
.event-tooltip .event-details .event-professional-avatar img, .calendar-event-container .event-professional-avatar img {
  width: 24px;
  height: 24px;
}

.calendar-event-container {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  --avatar-text: var(--text);
}
.calendar-event-container .calendar-event-inside {
  --text: var(--on-fill-text);
  --text-muted: var(--on-fill-text-muted);
  --danger: var(--on-fill-danger);
  container-name: event;
  container-type: inline-size;
  border: 1px solid;
  overflow: hidden;
  height: 100%;
  background-color: inherit;
  border-radius: var(--border-radius);
  padding: 2px 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.calendar-event-container .calendar-event-inside .event-header {
  display: none;
}
.calendar-event-container .calendar-event-inside .event-time {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-regular);
  color: var(--text);
  white-space: nowrap;
}
.calendar-event-container .calendar-event-inside .event-professional {
  font-size: var(--font-size-2xs);
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
}
.calendar-event-container .calendar-event-inside .event-professional .event-professional-avatar {
  color: var(--avatar-text);
}
.calendar-event-container .calendar-event-inside .event-status {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
  color: var(--text-muted);
}
.calendar-event-container .calendar-event-inside .event-status .cancel-by-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  color: var(--surface-0);
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-bold);
  margin-right: var(--space-1);
}
.calendar-event-container .calendar-event-inside .event-status .cancel-by-badge.cancel-by-employee {
  background-color: var(--accent);
}
.calendar-event-container .calendar-event-inside .event-status .cancel-by-badge.cancel-by-client {
  background-color: var(--info);
}
.calendar-event-container .calendar-event-inside .event-status .event-cancel-time {
  font-weight: var(--font-weight-regular);
}
.calendar-event-container .calendar-event-inside .event-type {
  font-size: var(--font-size-2xs);
  background: inherit;
  color: var(--on-pill-text);
  padding: var(--space-0-5) var(--space-2);
  border-radius: 4px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 4px;
}
.calendar-event-container .calendar-event-inside .event-type .event-type-branch-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid var(--on-color-border);
}
.calendar-event-container .calendar-event-inside .event-title {
  font-size: var(--font-size-xs);
  color: var(--text);
  overflow: visible;
  word-wrap: normal;
}
.calendar-event-container .calendar-event-inside .event-title.reservation-calendar-did-not-attend {
  color: var(--danger);
}
.calendar-event-container .calendar-event-inside .event-custom-title {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.calendar-event-container .calendar-event-inside .event-informative-professional {
  font-size: var(--font-size-2xs);
  font-style: italic;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 4px;
}
.calendar-event-container .calendar-event-inside .event-informative-professional i {
  font-size: var(--font-size-2xs);
}
.calendar-event-container .calendar-event-inside .event-capacity {
  font-size: var(--font-size-2xs);
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 4px;
}
.calendar-event-container .calendar-event-inside .event-capacity::before {
  content: "";
  width: 12px;
  height: 12px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%236c757d" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.calendar-event-container .calendar-event-inside .event-branch {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.calendar-event-container .calendar-event-inside .event-branch i {
  font-size: var(--font-size-2xs);
}
.calendar-event-container .calendar-event-inside .event-attendance {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: var(--font-size-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--surface-0);
  box-shadow: var(--shadow-2);
}
.rbc-month-view .calendar-event-container .calendar-event-inside {
  padding: var(--space-0-5) var(--space-2);
  flex-direction: row;
  align-items: center;
  gap: var(--space-2);
}
.rbc-month-view .calendar-event-container .calendar-event-inside .event-type {
  font-size: var(--font-size-2xs);
  padding: 0 4px;
}
.rbc-month-view .calendar-event-container .calendar-event-inside .event-title,
.rbc-month-view .calendar-event-container .calendar-event-inside .event-capacity,
.rbc-month-view .calendar-event-container .calendar-event-inside .event-custom-title,
.rbc-month-view .calendar-event-container .calendar-event-inside .event-informative-professional {
  display: none;
}
.rbc-month-view .calendar-event-container .calendar-event-inside .event-attendance {
  position: static;
  width: auto;
  height: auto;
  background: none;
  box-shadow: none;
  margin-left: auto;
  font-size: var(--font-size-xs);
}

:root .calendar-event-tooltip.p-tooltip {
  position: fixed;
  opacity: 1;
  transform: none !important;
}
:root .calendar-event-tooltip.p-tooltip.p-tooltip-right {
  margin-left: 8px;
}
:root .calendar-event-tooltip.p-tooltip .p-tooltip-arrow {
  display: none;
}
:root .calendar-event-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--surface-card);
  border: 1px solid var(--surface-border);
  box-shadow: none;
  padding: 8px;
}

.event-tooltip {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
}
.event-tooltip strong {
  color: var(--text);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}
.event-tooltip .event-tooltip-title {
  color: var(--text);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  margin-top: -4px;
}
.event-tooltip .event-details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.event-tooltip .event-details div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text);
  font-size: var(--font-size-sm);
}
.event-tooltip .event-details div i {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--accent);
}
.event-tooltip .event-details div i.error {
  color: var(--danger);
}
.event-tooltip .event-details .reservation-calendar-did-not-attend {
  color: var(--danger);
}
.event-tooltip .event-details .reservation-calendar-did-not-attend span,
.event-tooltip .event-details .reservation-calendar-did-not-attend i {
  color: var(--danger);
}
.event-tooltip .event-details .event-tooltip-attendees {
  flex-direction: column;
  gap: 4px;
  margin-left: 24px;
  align-items: start;
}
.event-tooltip .event-details .event-tooltip-attendees span {
  font-size: var(--font-size-2xs);
  opacity: 0.8;
  font-weight: var(--font-weight-semibold);
}

@container event (max-width: 40px) {
  .event-time-end {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
